module.exports = __webpack_public_path__ + "static/share-4f594197c10f090732340956eb2e3c23.jpg";